import Swal from 'sweetalert2'
import { createMuiTheme } from '@material-ui/core'

export const pickerTheme = createMuiTheme({
  overrides: {
    MuiPickersStaticWrapper: {
      staticWrapperRoot: {
        display: 'flex',
        overflow: 'hidden',
        minWidth: '310px',
        flexDirection: 'column',
        backgroundColor: '#fff',
        width: '100%',
        border: '2px solid #3984f7',
        borderRadius: '1em',
        height: '100%'
      }
    },
    MuiPickersDatePickerRoot: {
      toolbarLandscape: {
        padding: '1em',
        width: '30%',
        height: '100%'
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#3984f7'
      },
      toolbarLandscape: {
        maxWidth: 'none'
      }
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        color: '#fff'
      },
      toolbarBtnSelected: {
        color: '#fff'
      }
    },
    MuiPickersBasePicker: {
      pickerView: {
        display: 'flex',
        minWidth: '310px',
        minHeight: '330px',
        overflowX: 'hidden',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '70%',
        maxWidth: 'none'
      },
      containerLandscape: {
        height: '100%',
        width: '100%'
      }
    },
    MuiPickersToolbarButton: {
      toolbarBtn: {
        pointerEvents: 'none'
      }
    },
    MuiPickersCalendarHeader: {
      dayLabel: {
        width: '100%'
      }
    },
    MuiPickersCalendar: {
      transitionContainer: {
        height: '100%',
        width: '100%'
      },
      week: {
        justifyContent: 'space-around'
      }
    },
    MuiPickersYear: {
      yearSelected: {
        color: '#0651C4'
      }
    },
    MuiPickersClock: {
      pin: {
        backgroundColor: '#3984f7 !important'
      }
    },
    MuiPickersClockPointer: {
      pointer: {
        backgroundColor: '#3984f7 !important'
      },
      thumb: {
        borderColor: '#3984f7 !important'
      },
      noPoint: {
        backgroundColor: '#3984f7 !important'
      }
    }
  }
})

export const defaultFilter = {
  filterName: '',
  accountID: '',
  fastFilterID: '',
  // What is the actual min/max?
  severityMin: 0,
  severityMax: 100,
  usernames: [],
  usersToAdd: [],
  usersToDelete: [],
  station_ips: [],
  applications: [],
  workstations: [],
  workstationsToAdd: [],
  workstationsToDelete: [],
  categories: [],
  categoriesToAdd: [],
  categoriesToDelete: [],
  captureAreas: [],
  statusesToAdd: [],
  statusesToDelete: [],
  phrase: '',
  websiteUrl: '',
  additionalTerms: [],
  violationIDs: [],
  includeViolationIDs: [],
  units: [],
  source: 'all',
  startTime: '',
  endTime: '',
  startDate: '',
  endDate: '',
  sort: 'reportedAt: desc',
  refresh: true,
  isFastFilter: 0
}

export const linkStorageID = 'storedLinkID'

export const Toast = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  // customClass: 'swal-margin-top',
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

export const statusStyles = theme => ({
  /* Solved Status */
  'solved-status-color': {
    backgroundColor: '#A6FFFF'
  },
  /* Hold Status */
  'hold-status-color': {
    backgroundColor: '#FFFF91'
  },
  /* New Status */
  'new-status-color': {
    backgroundColor: '#CB9BFF'
  },
  /* Problem Status */
  'problem-status-color': {
    backgroundColor: '#FFA593'
  },
  /* No Problemo Status */
  'no-problem-status-color': {
    backgroundColor: '#96E1A8'
  },
  /* Change Status */
  orangeStatusColor: {
    backgroundColor: '#ffa500'
  }
})

export const captureUrlStatuses = {
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
  PENDING: 'PENDING'
}

// 'capture areas' by capture status
export const statusTypes = {
  ALL_CAPTURES: 'A',
  PROBLEM: 'P',
  NOT_A_PROBLEM: 'N',
  UNVIEWED: 'U',
  HOLD: 'H',
  RESOLVED: 'S',
  FLAGGED: 'Flagged'
}

export const statusPermissions = {
  [statusTypes.HOLD]: 'view-hold',
  [statusTypes.NOT_A_PROBLEM]: 'view-not-a-problem',
  [statusTypes.PROBLEM]: 'view-problem',
  [statusTypes.RESOLVED]: 'view-resolved',
  [statusTypes.UNVIEWED]: 'view-unviewed'
}

// detailed information for each status
export const statusFilterDetails = [
  {
    statusValue: statusTypes.UNVIEWED,
    statusLabel: 'Unviewed',
    statusPermission: statusPermissions[statusTypes.UNVIEWED],
    reportField: 'all_unviewed'
  },
  {
    statusValue: statusTypes.PROBLEM,
    statusLabel: 'Problem',
    statusPermission: statusPermissions[statusTypes.PROBLEM],
    reportField: 'all_problem'
  },
  {
    statusValue: statusTypes.NOT_A_PROBLEM,
    statusLabel: 'Not A Problem',
    statusPermission: statusPermissions[statusTypes.NOT_A_PROBLEM],
    reportField: 'all_not_a_problem'
  },
  {
    statusValue: statusTypes.HOLD,
    statusLabel: 'Hold',
    statusPermission: statusPermissions[statusTypes.HOLD],
    reportField: 'all_held'
  },
  {
    statusValue: statusTypes.RESOLVED,
    statusLabel: 'Resolved',
    statusPermission: statusPermissions[statusTypes.RESOLVED],
    reportField: 'all_resolved'
  }
]

export const loadingAreas = {
  FETCH_SUPPORT_KEY: 'fetch-support-key',
  SEARCH_VIOLATIONS: 'search-violations'
}
